// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "mltraining/internalapi/v1/mltraining.proto" (package "mltraining.internalapi.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Internal and private ml training annotations RPCs and protos
//
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { InternalMLTrainingService } from "./mltraining";
import type { GetModelRetrainingScheduleResponse } from "./mltraining";
import type { GetModelRetrainingScheduleRequest } from "./mltraining";
import type { SetModelRetrainingScheduleResponse } from "./mltraining";
import type { SetModelRetrainingScheduleRequest } from "./mltraining";
import type { ValidateTrainingJobResponse } from "./mltraining";
import type { ValidateTrainingJobRequest } from "./mltraining";
import type { GetModelMetricsForJobResponse } from "./mltraining";
import type { GetModelMetricsForJobRequest } from "./mltraining";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { SubmitHyperparameterTuningJobResponse } from "./mltraining";
import type { SubmitHyperparameterTuningJobRequest } from "./mltraining";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service mltraining.internalapi.v1.InternalMLTrainingService
 */
export interface IInternalMLTrainingServiceClient {
    /**
     * SubmitHyperparameterTuningJob submits a hyperparameter tuning job request.
     *
     * @generated from protobuf rpc: SubmitHyperparameterTuningJob(mltraining.internalapi.v1.SubmitHyperparameterTuningJobRequest) returns (mltraining.internalapi.v1.SubmitHyperparameterTuningJobResponse);
     */
    submitHyperparameterTuningJob(input: SubmitHyperparameterTuningJobRequest, options?: RpcOptions): UnaryCall<SubmitHyperparameterTuningJobRequest, SubmitHyperparameterTuningJobResponse>;
    /**
     * GetModelMetricsForJob gets the model metrics for a given job.
     *
     * @generated from protobuf rpc: GetModelMetricsForJob(mltraining.internalapi.v1.GetModelMetricsForJobRequest) returns (mltraining.internalapi.v1.GetModelMetricsForJobResponse);
     */
    getModelMetricsForJob(input: GetModelMetricsForJobRequest, options?: RpcOptions): UnaryCall<GetModelMetricsForJobRequest, GetModelMetricsForJobResponse>;
    /**
     * ValidateTrainingJob validates a training job before submission.
     *
     * @generated from protobuf rpc: ValidateTrainingJob(mltraining.internalapi.v1.ValidateTrainingJobRequest) returns (mltraining.internalapi.v1.ValidateTrainingJobResponse);
     */
    validateTrainingJob(input: ValidateTrainingJobRequest, options?: RpcOptions): UnaryCall<ValidateTrainingJobRequest, ValidateTrainingJobResponse>;
    /**
     * SetModelRetrainingSchedule sets or clears the retraining cron schedule on an ML model registry item.
     *
     * @generated from protobuf rpc: SetModelRetrainingSchedule(mltraining.internalapi.v1.SetModelRetrainingScheduleRequest) returns (mltraining.internalapi.v1.SetModelRetrainingScheduleResponse);
     */
    setModelRetrainingSchedule(input: SetModelRetrainingScheduleRequest, options?: RpcOptions): UnaryCall<SetModelRetrainingScheduleRequest, SetModelRetrainingScheduleResponse>;
    /**
     * GetModelRetrainingSchedule returns the current retraining schedule for an ML model registry item.
     *
     * @generated from protobuf rpc: GetModelRetrainingSchedule(mltraining.internalapi.v1.GetModelRetrainingScheduleRequest) returns (mltraining.internalapi.v1.GetModelRetrainingScheduleResponse);
     */
    getModelRetrainingSchedule(input: GetModelRetrainingScheduleRequest, options?: RpcOptions): UnaryCall<GetModelRetrainingScheduleRequest, GetModelRetrainingScheduleResponse>;
}
/**
 * @generated from protobuf service mltraining.internalapi.v1.InternalMLTrainingService
 */
export class InternalMLTrainingServiceClient implements IInternalMLTrainingServiceClient, ServiceInfo {
    typeName = InternalMLTrainingService.typeName;
    methods = InternalMLTrainingService.methods;
    options = InternalMLTrainingService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * SubmitHyperparameterTuningJob submits a hyperparameter tuning job request.
     *
     * @generated from protobuf rpc: SubmitHyperparameterTuningJob(mltraining.internalapi.v1.SubmitHyperparameterTuningJobRequest) returns (mltraining.internalapi.v1.SubmitHyperparameterTuningJobResponse);
     */
    submitHyperparameterTuningJob(input: SubmitHyperparameterTuningJobRequest, options?: RpcOptions): UnaryCall<SubmitHyperparameterTuningJobRequest, SubmitHyperparameterTuningJobResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<SubmitHyperparameterTuningJobRequest, SubmitHyperparameterTuningJobResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * GetModelMetricsForJob gets the model metrics for a given job.
     *
     * @generated from protobuf rpc: GetModelMetricsForJob(mltraining.internalapi.v1.GetModelMetricsForJobRequest) returns (mltraining.internalapi.v1.GetModelMetricsForJobResponse);
     */
    getModelMetricsForJob(input: GetModelMetricsForJobRequest, options?: RpcOptions): UnaryCall<GetModelMetricsForJobRequest, GetModelMetricsForJobResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetModelMetricsForJobRequest, GetModelMetricsForJobResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * ValidateTrainingJob validates a training job before submission.
     *
     * @generated from protobuf rpc: ValidateTrainingJob(mltraining.internalapi.v1.ValidateTrainingJobRequest) returns (mltraining.internalapi.v1.ValidateTrainingJobResponse);
     */
    validateTrainingJob(input: ValidateTrainingJobRequest, options?: RpcOptions): UnaryCall<ValidateTrainingJobRequest, ValidateTrainingJobResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<ValidateTrainingJobRequest, ValidateTrainingJobResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * SetModelRetrainingSchedule sets or clears the retraining cron schedule on an ML model registry item.
     *
     * @generated from protobuf rpc: SetModelRetrainingSchedule(mltraining.internalapi.v1.SetModelRetrainingScheduleRequest) returns (mltraining.internalapi.v1.SetModelRetrainingScheduleResponse);
     */
    setModelRetrainingSchedule(input: SetModelRetrainingScheduleRequest, options?: RpcOptions): UnaryCall<SetModelRetrainingScheduleRequest, SetModelRetrainingScheduleResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<SetModelRetrainingScheduleRequest, SetModelRetrainingScheduleResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * GetModelRetrainingSchedule returns the current retraining schedule for an ML model registry item.
     *
     * @generated from protobuf rpc: GetModelRetrainingSchedule(mltraining.internalapi.v1.GetModelRetrainingScheduleRequest) returns (mltraining.internalapi.v1.GetModelRetrainingScheduleResponse);
     */
    getModelRetrainingSchedule(input: GetModelRetrainingScheduleRequest, options?: RpcOptions): UnaryCall<GetModelRetrainingScheduleRequest, GetModelRetrainingScheduleResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetModelRetrainingScheduleRequest, GetModelRetrainingScheduleResponse>("unary", this._transport, method, opt, input);
    }
}
